/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import _ from 'lodash';
import Select from 'react-select';
import TimeSelect from './TimeSelect';
import TimezoneSelect from './TimezoneSelect';
import Alert from './Alert';
import { Link } from 'react-router-dom';
import ConfirmationModal from './ConfirmationModal';
import BP_METHODS from './BPMethods';

const Api = require('./Config');

// Be sure to include styles at some point, probably during your bootstrapping
const box = {
  boxShadow: '0 4px 10px 0 rgba(0, 0, 0, .5)',
  marginBottom: '30px',
  marginTop: '30px',
  padding: '50px 80px',
};
const title = { fontSize: '24px', fontWeight: '500', marginBottom: '30px' };
const actions = { marginTop: '40px' };
const container = { margin: '20px 0' };



const all_bp_methods = [{
      name: BP_METHODS.normal,
      value: 'normal'
      },{
      name: BP_METHODS.bp_cuff,
      value: 'bp_cuff'

      },{
      name: BP_METHODS.bp_ai,
      value: 'bp_ai'
      }]

  
 const bp_methods_no_face= all_bp_methods.filter((a) => a.value !== 'bp_ai');     

export default class EditDoctor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      selected_club: null,
      doctor_user_name: '',
      doctor_password: '',
      doctor_remark: '',
      loading: false,
      phone_number: '',
      fax: '',
      password_help: '',
      tracker_question: '',
      tracker_no_response: '',
      journeys: [],
      selected_journey: null,
      fallback_emergency_msg_txt: '',
      emergency_msg_txt: '',
      doctor_id: null,
      phone_link: '',
     default_bp_method: 'normal',
      weight_required_default: false,
      weight_confirmation_modal: false,
      number_of_tcodes_with_weight_on: 0,
      hl7_match_2_required: false,
      npi_format_required: false,
      notification_time: null,
      notification_timezone: null,
      allow_facial_scan: false,
      bp_methods: bp_methods_no_face, // default to no facial scan
    };
  }

  componentDidMount() {
    this.id = this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/') + 1);
    if (this.id == null) {
      return;
    }
    Api.getADoctor(this.id)
      .then((doc) => {
        const current_club = { club_id: doc.app_code, clubname: unescape(doc.clubname) };
        this.setState({
          selected_club: current_club,
          doctor_user_name: doc.username,
          doctor_password: 'NO_CHANGE_CHANGE',
          doctor_remark: doc.remark,
          phone_number: doc.phone_number,
          fax: doc.fax,
          password_help: doc.password_help,
          loading: false,
          title: doc.title,
          tracker_question: doc.tracker_question,
          tracker_no_response: doc.tracker_no_response,
          doctor_id: doc.id,
          default_bp_method: doc.default_bp_method,
          allow_facial_scan: doc.ai_bp_allowed === 'Y',
          hl7_match_2_required: doc.hl7_match_2_required === 'Y',
          npi_format_required: doc.npi_format_required === 'Y',
          weight_required_default: doc.weight_required_default === 'Y',
          number_of_tcodes_with_weight_on: doc.number_of_tcodes_with_weight_on,
          notification_time: doc.notification_time || Api.DEFAULT_NOTIFICATION_TIME,
          notification_timezone: doc.notification_timezone || Api.DEFAULT_NOTIFICATION_TIMEZONE,
        });


        // set the bp methods based on the allow facial scan  
        if (doc.ai_bp_allowed === 'Y') {
          this.setState({
            bp_methods: all_bp_methods,
            
          });
        } else {
          this.setState({
            bp_methods: bp_methods_no_face,
             
          });
        }




        this.getApps(current_club);
      })
      .catch((err) => {
        console.log(err);
      });

    Api.getJourneyMaster(Api.EXCLUDED_JIDS)
      .then((journeys) => {
        let journeys_with_emergency = journeys.filter((journey) => {
          return journey.show_emergency_alert === 'Y';
        });
        this.setState({ journeys: journeys_with_emergency });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getApps(current_club) {
    Api.getApps(true)
      .then((papps) => {
        let apps = _.map(papps, (a, b) => {
          a.clubname = unescape(a.clubname);
          return a;
        });

        // add the current club
        apps.unshift(current_club);

        this.setState({
          apps,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getEmergencyResponse(jid, doc_id) {
    Api.getEmergencyResponse(jid, doc_id, null)
      .then((data) => {
        // only populate the textarea when the response text is a doctor office override
        let text = '';
        if (data.response.office_response) {
          text = data.response.office_response;
        }

        let fallback_text = '';
        if (data.response.journey_response) {
          fallback_text = data.response.journey_response;
        } else if (data.response.default_response_text) {
          fallback_text = data.response.default_response_text;
        }

        this.setState({
          fallback_emergency_msg_txt: fallback_text,
          emergency_msg_txt: text,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleJourneySelect(journey) {
    this.getEmergencyResponse(journey.JID, this.state.doctor_id);
    this.setState({
      selected_journey: journey,
    });
  }

  emergencyResponseSubmit() {
    Api.updateEmergencyResponseByOffice(
      this.state.selected_journey.JID,
      this.state.doctor_id,
      this.state.emergency_msg_txt
    )
      .then((data) => {
        if (data.success) {
          this.alert.open('SUCCESS', 'Emergency message updated successfully.');
        } else {
          this.alert.open('Error', `${data.reason}`);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  addPhoneLink() {
    const fullPhoneLink = '<PHONE_LINK>' + this.state.phone_link + '</PHONE_LINK>';
    this.setState({
      emergency_msg_txt: this.state.emergency_msg_txt + ' ' + fullPhoneLink,
      phone_link: '',
    });
  }

  doSubmit() {
    if (this.state.doctor_user_name.length <= 4) {
      this.alert.open('Error', 'username should be more than 4 letter');
      return;
    }
    if (this.state.doctor_password.length <= 4) {
      this.alert.open('Error', 'password should be more than 4 letter');
      return;
    }
    if (this.state.title.length <= 0) {
      this.alert.open('Error', 'Office Name is required');
      return;
    }
    if (this.state.selected_club == null) {
      this.alert.open('Error', 'please select club');
      return;
    }

    // if it is set to off, add confirmation
    if (this.state.weight_required_default == false && parseInt(this.state.number_of_tcodes_with_weight_on) > 0) {
      this.setState({ weight_confirmation_modal: true });
    } else {
      this.updateDoctorOffice();
    }
  }

  updateDoctorOffice() {
    let time = this.state.notification_time;
    let timezone = this.state.notification_timezone;
    if (
      this.state.notification_time == Api.DEFAULT_NOTIFICATION_TIME &&
      this.state.notification_timezone == Api.DEFAULT_NOTIFICATION_TIMEZONE
    ) {
      time = '';
      timezone = '';
    }

    Api.updateADoctor(
      this.id,
      this.state.doctor_user_name,
      this.state.doctor_password,
      this.state.selected_club.club_id,
      this.state.doctor_remark,
      this.state.phone_number,
      this.state.fax,
      this.state.title,
      this.state.password_help,
  this.state.default_bp_method,
      this.state.allow_facial_scan,
      this.state.hl7_match_2_required,
      this.state.npi_format_required,
      this.state.weight_required_default,
      time,
      timezone
    )
      .then((resp) => {
        if (resp.SUCCESS == 'YES') {
          this.alert.open('SUCCESS', 'Office updated successfully.');
          this.setState({
            loading: false,
            weight_confirmation_modal: false,
          });
        } else {
          this.alert.open('Error', resp.REASON);
          this.setState({
            loading: false,
            weight_confirmation_modal: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
          weight_confirmation_modal: false,
        });
        this.alert.open('Error', `${err}`);
      });
  }

  itemSelected(obj) {
    this.setState({
      selected_club: obj,
    });
  }

  render() {
    return (
      <div>
        <div className="row" style={container}>
          <div className="col-md-8 col-md-offset-2" style={box}>
            <div style={{ ...title, marginTop: 30 }}>Edit Office Details</div>
            <div className="content">
              <div className="form-group">
                <label> App ID: </label>
                <Select
                  onChange={(obj) => {
                    this.itemSelected(obj);
                  }}
                  value={this.state.selected_club}
                  getOptionLabel={(a) => a.clubname}
                  getOptionValue={(a) => a.club_id}
                  options={this.state.apps}
                />
              </div>
              <div className="form-group">
                <label> Ofc Username: </label>
                <input
                  type="text"
                  value={this.state.doctor_user_name}
                  onChange={(e) => {
                    this.setState({
                      doctor_user_name: e.target.value,
                    });
                  }}
                  placeholder="Username"
                  className="form-control"
                />
              </div>
              <div className="row">
                <div className="col-md-6">
                  {' '}
                  <div className="form-group">
                    <label> Ofc Password: </label>
                    <input
                      value={this.state.doctor_password}
                      name={`dd${new Date().getTime()}`}
                      autoComplete="new-password"
                      type="password"
                      placeholder=""
                      className="form-control"
                      onChange={(e) => {
                        this.setState({
                          doctor_password: e.target.value,
                          password_help: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  {' '}
                  <div className="form-group">
                    <label> Password Hint: </label>
                    <input
                      value={this.state.password_help}
                      autoComplete="new-password"
                      type="text"
                      placeholder=""
                      className="form-control"
                      onChange={(e) => {
                        this.setState({
                          password_help: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label> Ofc Name: </label>{' '}
                <input
                  value={this.state.title}
                  type="text"
                  placeholder="Name"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      title: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="form-group">
                <label> Ofc Phone number: </label>{' '}
                <input
                  value={this.state.phone_number}
                  type="text"
                  placeholder="Phone number"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      phone_number: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="row">
                <div className="form-group col-md-6">
                  <label> Ofc Fax: </label>{' '}
                  <input
                    type="text"
                    placeholder="Fax"
                    className="form-control"
                    value={this.state.fax}
                    onChange={(e) => {
                      this.setState({
                        fax: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6" style={{ paddingTop: 25 }}>
                  <button
                    type="button"
                    className="btn btn-danger col-xs-4 col-xs-offset-1"
                    disabled={this.state.loading}
                    onClick={() => {
                      this.setState({ loading: true });
                      Api.adminTestFax(this.state.doctor_user_name, this.state.fax)
                        .then((data) => {
                          this.setState({ loading: false });
                          if (data.RESULT == 'SUCCESS') {
                            this.alert.open('Success', `Fax sent with id ${data.SID}`);
                          } else {
                            this.alert.open('FAILED', `FAx failed with message ${data.FAIL}`);
                          }
                        })
                        .catch((err) => {
                          this.setState({ loading: false });
                          this.alert.open('Error', `${err}`);
                        });
                    }}
                  >
                    {' '}
                    Test Fax{' '}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label> Ofc Remark: </label>{' '}
                <input
                  type="text"
                  placeholder="Remark"
                  className="form-control"
                  value={this.state.doctor_remark}
                  onChange={(e) => {
                    this.setState({
                      doctor_remark: e.target.value,
                    });
                  }}
                />
              </div>
           


       <div className="form-group" style={{ padding: 10  }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.allow_facial_scan}
                      onChange={(e) => {
                        this.setState({
                          allow_facial_scan: e.target.checked,
                        });
                        if(e.target.checked){
                          this.setState({
                            bp_methods: all_bp_methods,
                            default_bp_method: 'bp_ai',
                          });
                        }else{
                          this.setState({
                            bp_methods: bp_methods_no_face,
                            default_bp_method: 'normal',
                          });
                        } 



                      }}  
                   
                    
              
                    />
                    Allow Facial scan
                  </label>
                </div>
              </div>


           
           
           
             <div className="form-group" style={{ padding: 10, backgroundColor: '#c7eaf2' }}>
                <label>Default BP Method</label>
               <div style={{ width: '240px' }}>
                  <select
                  className='form-control'
                
                  value={this.state.default_bp_method}
                 
                  onChange={(e) => {
                   
                    this.setState({
                      default_bp_method: e.target.value,
                    });
                  }}
               
                >
              {
                    this.state.bp_methods.map((a) => {
                      return (
                        <option key={a.value} value={a.value}>
                          {a.name}
                        </option>
                      );
                    })

              }
               


                  </select>
                </div>
                </div>

              <div className="form-group" style={{ padding: 10, backgroundColor: '#AFE1AF' }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.weight_required_default}
                      onChange={(e) => {
                        this.setState({
                          weight_required_default: e.target.checked,
                        });
                      }}
                    />
                    Request for Weight on HTN Journeys
                  </label>
                </div>
              </div>
              <div className="form-group" style={{ padding: 10 }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.hl7_match_2_required}
                      onChange={(e) => {
                        this.setState({
                          hl7_match_2_required: e.target.checked,
                        });
                      }}
                    />
                    Require 2nd matching value to HL7 files
                  </label>
                </div>
              </div>
              <div className="form-group" style={{ padding: 10 }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.npi_format_required}
                      onChange={(e) => {
                        this.setState({
                          npi_format_required: e.target.checked,
                        });
                      }}
                    />
                    Require NPI Format
                  </label>
                </div>
              </div>
              <div style={{ marginBottom: 10 }}></div>
              <div style={title}>
                <h3 style={{ paddingTop: 25 }}>Set Notification Time</h3>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <TimeSelect
                      selectedTime={this.state.notification_time}
                      startTime="06:00"
                      endTime="20:00"
                      interval={1}
                      period="hours"
                      handleChange={(value) => {
                        this.setState({
                          notification_time: value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <TimezoneSelect
                      selectedTimezone={this.state.notification_timezone}
                      handleChange={(value) => {
                        this.setState({
                          notification_timezone: value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={actions}>
                <button
                  type="button"
                  className="btn btn-primary col-xs-4 col-xs-offset-3"
                  disabled={this.state.loading}
                  onClick={() => {
                    this.doSubmit();
                  }}
                >
                  Save
                </button>
                <Link style={{ marginLeft: '10px' }} className="btn btn-default" to="/RegisterDoctor">
                  Cancel
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-8 col-md-offset-2" style={box}>
            <div style={title}>Journey Emergency Messaging</div>
            <div className="content">
              <div className="form-group">
                <label> Journey: </label>
                <Select
                  onChange={(journey) => {
                    this.handleJourneySelect(journey);
                  }}
                  value={this.state.selected_journey}
                  getOptionLabel={(a) => a.journey_name}
                  getOptionValue={(a) => a.JID}
                  options={this.state.journeys}
                />
              </div>
              {this.state.selected_journey && (
                <div>
                  <div className="form-group">
                    <label> Emergency Message: </label>
                    <textarea
                      style={{ minHeight: 200 }}
                      className="form-control"
                      placeholder={this.state.fallback_emergency_msg_txt}
                      value={this.state.emergency_msg_txt}
                      onChange={(e) => {
                        this.setState({ emergency_msg_txt: e.target.value });
                      }}
                    ></textarea>
                    <div className="add-phone-link" style={{ marginBottom: '50px', marginTop: '20px' }}>
                      <div className="input-group">
                        <input
                          value={this.state.phone_link}
                          type="text"
                          placeholder="Phone Number"
                          className="form-control"
                          onChange={(e) => {
                            this.setState({
                              phone_link: e.target.value,
                            });
                          }}
                        />
                        <span className="input-group-btn">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              this.addPhoneLink();
                            }}
                          >
                            + Add Phone Link
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div style={actions}>
                    <button
                      type="button"
                      className="btn btn-primary col-xs-4 col-xs-offset-3"
                      disabled={this.state.loading}
                      onClick={() => {
                        this.emergencyResponseSubmit();
                      }}
                    >
                      Save
                    </button>
                    <Link style={{ marginLeft: '10px' }} className="btn btn-default" to="/RegisterDoctor">
                      Cancel
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>{' '}
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
        <ConfirmationModal
          show={this.state.weight_confirmation_modal}
          title="Confirm turning off weight question"
          confirmationText={`There are ${this.state.number_of_tcodes_with_weight_on} tcodes that have weight question turned on. Are you sure you wanna turn it off for all the existing tcodes?`}
          handleConfirm={() => {
            this.updateDoctorOffice();
          }}
          handleClose={() => {
            this.setState({ weight_confirmation_modal: false });
          }}
        />
      </div>
    );
  }
}
